<template>
    <nav class="mobile-nav">
        <i class="fa fa-times fechar_icone" aria-hidden="true" @click="$emit('fechaNavbar')"></i>
        <h2>SESAU</h2>
        <h2>Censo</h2>
        <div class="divisor-navbar"></div>
        <ul>
            <li>
                <a href="/painel">Painel</a>
            </li>
            <li @click="$emit('fechaNavbar')">
                <router-link :to="{ name: 'home' }">Censo</router-link>
            </li>

            <li>
                <a href="#" @click="dropdownRelatorio = !dropdownRelatorio">Relatórios <i class="fa fa-caret-down" aria-hidden="true"></i></a>
                <div v-if="dropdownRelatorio == true" class="dropdown-content-mobile"  @click="$emit('fechaNavbar')">
                    <router-link class="d-block mt-2 mb-2" :to="{ name: 'ocupacaomeianoite' }" >Ocupação Meia Noite</router-link>
                    <router-link class="d-block mb-2" :to="{ name: 'pacientesinternados' }" >Pacientes Admitidos</router-link>
                    <router-link class="d-block mb-2" :to="{ name: 'historicointernacoes' }" >Histórico de Admissões</router-link>
                    <router-link class="d-block mb-2" :to="{ name: 'historicomovimentacao' }" >Histórico de Movimentação de Leito</router-link>
                    <router-link class="d-block mb-2" :to="{ name: 'relatoriolongapermanencia' }">Pacientes acima de 24h</router-link>
                    <router-link class="d-block mb-2" :to="{ name: 'relatorioListagemInternacoes' }">Listagem de Admissões</router-link>
                </div>
            </li>

            <li>
                <a href="/publico/controller/encerrarSessao.php">Sair</a>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        mounted () {
            document.documentElement.addEventListener('click', event => {
               if (event.target === document.documentElement) this.$emit('fechaNavbar');
            })
        },
        data() {
            return {
                dropdownRelatorio: false
            }
        },
    }
</script>

<style>
    .mobile-nav {
        position: fixed;
        top: 0;
        height: 100vh;
        width: 426px;
        max-width: 94%;
        background-color: white;
        display: flex;
        flex-direction: column;
        z-index: 66;
        padding: 24px;
    }

    .fechar_icone {
        color: black;
        align-self: flex-end;
        margin: 1rem 1rem 2rem 0;
        cursor: pointer;
        font-size: 20px;
    }

    .divisor-navbar {
        margin: 1rem 0 2rem 0;
        border: .6px solid black;
    }

    .mobile-nav h2 {
        color: #255e8b;
        font-size: 1.7rem;
    }

    .mobile-nav h2:first-of-type {
        align-self: center;
    }

    .mobile-nav h2:last-of-type {
        align-self: center;
        font-weight: 300;
        margin-top: 1rem;
    }

    .mobile-nav li {
        margin-bottom: 0.4rem;
    }

    .mobile-nav a,
    .mobile-nav a:active,
    .mobile-nav a:hover {
        color: #255e8b;
        font-size: 1.4rem;
        cursor: pointer;
    }

    .dropdown-content-mobile {
        font-weight: 300;
    }

</style>

